import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

function SignedInPanel() {
  const { auth, logout } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="space-y-4 text-sm text-slate-900">
      <h2 className="mb-1 text-lg font-semibold tracking-tight sm:text-xl">
        {t('auth.signed_in_title')}
      </h2>
      <p className="text-xs text-slate-500 sm:text-sm">
        {t('auth.signed_in_body')}
      </p>

      <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700">
        <div className="flex items-center justify-between">
          <span className="font-medium text-slate-900">
            {t('auth.signed_in_label')}
          </span>
          <button
            type="button"
            onClick={logout}
            className="text-[11px] font-medium text-brand-300 hover:text-brand-200"
          >
            {t('auth.signed_in_logout')}
          </button>
        </div>
        <p className="mt-1 truncate text-slate-600">
          {auth.email || t('auth.signed_in_email_fallback')}
        </p>
      </div>
    </div>
  );
}

export default SignedInPanel;

